<script>
import ImageBoxTool from './ImageBoxTool';

export default {
  name: 'BringToFrontImageBoxTool',
  extends: ImageBoxTool,
  data() {
    return {
      icon: 'move-to-front',
      title: 'Move to front',
      showLocal: true,
      hotkey: 'meta+shift+up',
    };
  },
  computed: {
    show() {
      return this.showLocal;
    },
  },
  mounted() {
    this.$nextTick().then(() => {
      this.canvas.on({
        'selection:created': this.activate,
        'selection:updated': this.activate,
      });
      // this.canvas.on({
      //   'object:selected': () => { this.activate(); },
      //   'mouse:down': () => { this.activate(); },
      // });
    });
  },
  methods: {
    activate() {
      if (this.canvas.getActiveObject()) {
        this.showLocal = true;
      } else {
        this.showLocal = false;
      }
    },
    action() {
      if (this.canvas.getActiveObject()) {
        this.canvas.bringToFront(this.canvas.getActiveObject());
        this.canvas.fire('object:modified', { target: this.canvas.getActiveObject() });
      }
    },
  },
};
</script>
